/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    const stickyCon = document.querySelector('.sticky-con');
    document.addEventListener('scroll', () => {
    const totalHeight = document.documentElement.scrollHeight; 
    const viewportHeight = window.innerHeight; 
    const scrollPosition = window.scrollY; 
    const stopStickyPoint = totalHeight - (viewportHeight * 1.3); 

    if (scrollPosition > 800 && scrollPosition < stopStickyPoint) {
        stickyCon.classList.add('sticky-756');
    } else {
        stickyCon.classList.remove('sticky-756');
    }
});



  
 

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
